import { useEffect, useState } from 'react';

export default function useScrollMonitor(threshold = 2) {
  const [hasScrolled, setHasScrolled] = useState(typeof window !== 'undefined' && window.scrollY > threshold);

  const handleScroll = () => {
    window.requestAnimationFrame(() => setHasScrolled(window.scrollY > threshold));
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  return hasScrolled;
}
